export default function getVersion(): string {
  return `${APP_VERSION || ''}`;
}
